<template lang="pug">
  v-flex
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('labels.moduleBase') }}
        v-spacer
        toggle-button(@change="updateModule" :labels="true" color="indigo" v-model="location.moduleBase"  :sync="true")
      v-card-text(v-if="this.location.moduleBase")
        template(v-for="(row, index) in location.ModulesLinks")
          v-layout(row wrap)
            v-flex {{ row.Module.moduleName }} - {{ row.Module.price | currency }}
            v-spacer
            v-flex.text-xs-right
              toggle-button(@change="update(row)" :labels="true" v-model="row.status" :value="row.status" :sync="true")
          v-divider(v-if="index + 1 < location.ModulesLinks.length" :key="index")
        v-divider
        v-layout
          v-flex {{ $t('labels.total') }}
          v-spacer
          v-flex.text-xs-right.font-weight-regular {{ modualTotal | currency }}
        v-layout
          v-btn(block color="teal" @click="changeFee" v-if="checkRightStatus(10)" dark) Set {{ modualTotal | currency }} as software fee
</template>

<script>
import locationService from '../../service.js'
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      moduleBase: null
    }
  },
  computed: {
    ...mapGetters('location', ['location']),
    ...mapGetters('global', ['checkRightStatus']),
    modualTotal() {
      let total = 0
      this.location.ModulesLinks.map(row => {
        if (row.status) {
          total = total + row.Module.price
        }
      })
      return total
    }
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    update(val) {
      locationService.updateModule(val.id, {status: val.status})
      .then(result => {
        console.log('update', result)
      })
    },
    changeFee() {
      let data = {
        softwareFee: this.modualTotal,
        serviceID: 192
      }
      return locationService.updateProductRelation(this.location.storeID,data.serviceID, data)
      .then(result => {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        this.setLocation(this.location.storeID)
      })
    },
    updateModule() {
      let data = {
        moduleBase: this.location.moduleBase
      }
      return locationService.updateStore(this.location.storeID, data)
      .then(result => {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        // this.setLocation(this.location.storeID)
      })
    }
  }
}
</script>
